export const getError = (state) => state.login.get('_metadata').get('error');
export const getInProgress = (state) => !!state.login.get('_metadata').get('inProgress');
export const getShowErrorAlert = (state) => state.login.get('_metadata').get('showErrorAlert');
export const getAuthenticated = (state) => state.login.get('authenticated');
